<template>
  <v-dialog :key="data.dialogesite" v-model="data.dialogesite" width="900">
    <template v-slot:activator="{ on, attrs }">
      <v-card class="py-4" elevation="0" v-bind="attrs" v-on="on">
        <v-row>
          <v-col cols="1"
            ><v-icon color="secondary">fal fa-globe</v-icon>
          </v-col>
          <v-col cols="9">{{ data.website }} </v-col>
          <v-col cols="1" class="text-right">
           <v-icon color="dark">fal fa-pencil</v-icon>
          </v-col>
        </v-row>
      </v-card>
    </template>

    <v-card elevation="0" class="rounded-lg pa-5">
      <v-html class="overline">Website wijzigen</v-html>
      <v-spacer class="py-4"></v-spacer>
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="data.website"
            label="Website"
            outlined
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="ml-auto text-right">
          <v-btn color="secondary" right @click="submit" elevation="0">
            Opslaan
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    data: Object,
  },
};
</script>

